import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import Alerts from "../util/Alerts";
import axios from "axios";
import { routes } from "../gen/General";
import "./estilo.scss";
import { SeccionHeader, SeccionSalir } from "./ComponentPolizas";
import atras from "../assets/img/icon/icon_atras.svg";
import hospitalaria_on from "../assets/img/icon/icon_red_hospitalaria_on.svg";
import hospitalaria_off from "../assets/img/icon/icon_red_hospitalaria_off.svg";
import ambulatoria_on from "../assets/img/icon/icon_red_ambulatoria_on.svg";
import ambulatoria_off from "../assets/img/icon/icon_red_ambulatoria_off.svg";
import farmacias_on from "../assets/img/icon/icon_red_farmacias_on.svg";
import farmacias_off from "../assets/img/icon/icon_red_farmacias_off.svg";
import paquetes_on from "../assets/img/icon/icon_paquetes_selectos_on.svg";
import paquetes_off from "../assets/img/icon/icon_paquetes_selectos_off.svg";
import buscar_todos from "../assets/img/icon/icon_todos.svg";

export const RedBeneficios = props => {
    const [item, setItem] = useState({ hosp: 0, ambu: 0, farm: 0, selec: 0 });
    const [tp, setTp] = useState("");
    const [plan, setPlan] = useState({});

    const alert = React.useRef(null);
    const history = useHistory();

    useEffect(() => {
        fetchData(props.match.params.id);
        getPlan(props.match.params.id);
        setTp(props.match.params.tp);
    }, [props.match.params.id, props.match.params.tp]);

    function fetchData(id) {
        axios
            .get(routes.base + "/beneficio/tipo", { params: { cdPlan: id } })
            .then(resp => {
                // axios.get(routes.base + "/beneficio/tipo", {params: {cdPlan: 123}}).then(resp => {
                let list = resp.data;
                let ambu = (list || []).find(x => x.RED === "RED AMBULATORIA");
                let hosp = (list || []).find(x => x.RED === "RED HOSPITALARIA");
                let farm = (list || []).find(x => x.RED === "RED FARMACIA");
                let selec = (list || []).find(x => x.RED === "RED SELECTA");
                setItem({
                    hosp: hosp?.NUM ? hosp.NUM : 0,
                    ambu: ambu?.NUM ? ambu.NUM : 0,
                    farm: farm?.NUM ? farm.NUM : 0,
                    selec: selec?.NUM ? selec.NUM : 0,
                });
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getPlan(id) {
        axios
            .get(routes.base + "/plan", { params: { cdPlan: id } })
            .then(resp => {
                setPlan(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Row>
                <Col xs={12}>
                    <Card>
                        <SeccionHeader idx={2} />
                        <div className="row justify-content-between">
                            <SeccionAtras to={"/list/beneficios/" + tp} />
                            <SeccionSalir to={"/" + props.match.params.tp + "/polizas"} />
                        </div>
                        <CardHeader>
                            <Row>
                                <Col md={7}>
                                    <h4 className="titulos">Prestadores:</h4>
                                    <h4 className="sub-titulos">{plan ? plan.dscPlan : ""}</h4>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="container">
                                <button
                                    type={"button"}
                                    className={"btn beneficios__btn"}
                                    onClick={() =>
                                        history.push("/list/beneficios/" + tp + "/" + props.match.params.id + "/ALL")
                                    }
                                >
                                    <img src={buscar_todos} width={"15"} />
                                    &nbsp; Consultar en todas las redes
                                </button>
                                <Row>
                                    <Col md={12}>
                                        <Row>
                                            <BeneficioCard
                                                to={"/list/beneficios/" + tp + "/" + props.match.params.id + "/H"}
                                                title1={"Red"}
                                                title2={"Hospitalaria"}
                                                iconos={[hospitalaria_on, hospitalaria_off]}
                                                desc={
                                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                }
                                                count={item.hosp}
                                            />
                                            <BeneficioCard
                                                to={"/list/beneficios/" + tp + "/" + props.match.params.id + "/A"}
                                                title1={"Red"}
                                                title2={"Ambulatoria"}
                                                iconos={[ambulatoria_on, ambulatoria_off]}
                                                desc={
                                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                }
                                                count={item.ambu}
                                            />
                                            <BeneficioCard
                                                to={"/list/beneficios/" + tp + "/" + props.match.params.id + "/F"}
                                                title1={"Red"}
                                                title2={"Farmacias"}
                                                iconos={[farmacias_on, farmacias_off]}
                                                desc={
                                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                }
                                                count={item.farm}
                                            />
                                            <BeneficioCard
                                                to={"/list/beneficios/" + tp + "/" + props.match.params.id + "/S"}
                                                title1={"Paquetes"}
                                                title2={"Selectos"}
                                                iconos={[paquetes_on, paquetes_off]}
                                                desc={
                                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                }
                                                count={item.selec}
                                            />
                                        </Row>
                                        <br />
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

const BeneficioCard = ({ to, title1, title2, iconos, desc, count = 0 }) => {
    const [icono, setIcono] = useState(iconos[1]);

    const handleIconoOn = () => {
        setIcono(iconos[0]);
    };

    const handleIconoOff = () => {
        setIcono(iconos[1]);
    };

    const history = useHistory();

    return (
        <Col md={4} lg={3} className={"text-justify"}>
            <div
                className={"text-center c-pointer borde-redes"}
                onClick={() => history.push(to)}
                onMouseEnter={handleIconoOn}
                onMouseLeave={handleIconoOff}
            >
                <h4>{title1}</h4>
                <h4>{title2}</h4>
                <div>
                    <img src={icono} alt="" height={"175"} />
                </div>
                <h4 className={"text-secondary text-center m-0"}>{count}</h4>
            </div>
            <span className={"text-primary"}>{desc}</span>
        </Col>
    );
};

export const SeccionAtras = ({ to = "" }) => {
    const history = useHistory();

    return (
        <>
            <div className="font-medium text-primary c-pointer pl-atras" onClick={() => history.push(to)}>
                <img src={atras} alt="" width={"12"} />
                &nbsp;
                <span>Atrás</span>
            </div>
        </>
    );
};
